import { storyblokInit as a } from "./storyblok-js.mjs";
import { RichTextResolver as C, RichTextSchema as f, apiPlugin as h, loadStoryblokBridge as d, registerStoryblokBridge as S, renderRichText as x, storyblokEditable as F, registerStoryblokBridge as T } from "./storyblok-js.mjs";
import { default as B } from "./server-component.mjs";
let e = null;
const r = /* @__PURE__ */ new Map();
let n = !1, l = null;
globalThis.storyCache = globalThis.storyCache ? globalThis.storyCache : /* @__PURE__ */ new Map();
const i = () => (e || console.error(
  "You can't use getStoryblokApi if you're not loading apiPlugin."
), e), c = (o) => (Object.entries(o).forEach(([t, s]) => {
  r.set(t, s);
}), r), k = (o) => r.has(o) ? r.get(o) : (console.error(`Component ${o} doesn't exist.`), !1), m = () => n, p = () => l, u = (o = {}) => {
  if (e)
    return () => e;
  const { storyblokApi: t } = a(o);
  return e = t, o.components && c(o.components), n = o.enableFallbackComponent, l = o.customFallbackComponent, () => t;
};
export {
  C as RichTextResolver,
  f as RichTextSchema,
  B as StoryblokServerComponent,
  h as apiPlugin,
  k as getComponent,
  p as getCustomFallbackComponent,
  m as getEnableFallbackComponent,
  i as getStoryblokApi,
  d as loadStoryblokBridge,
  S as registerStoryblokBridge,
  x as renderRichText,
  c as setComponents,
  F as storyblokEditable,
  u as storyblokInit,
  i as useStoryblokApi,
  T as useStoryblokBridge
};
